<template>
  <div class="interestPage" v-show="openPop">
    <div class="interestContent" :class="{active: bl}">
      <div class="backBtn" @click.stop="backFn" v-show="chooseList.length < 2">
        <van-icon name="arrow-left" />
      </div>
      <div class="closeBtn" @click.stop="close" v-show="chooseList.length >= 2">
        <van-icon name="cross" />
      </div>
      <dl class="listWrapper">
        <dt>
          <h4>选择专业兴趣偏好</h4>
          <p>让我们更了解您，为你专属定制练习</p>
        </dt>
        <dd class="linearBg"></dd>
        <dd class="listBox">
          <div class="listContent flexBox">
            <div class="item" v-for="(item, key) in list" :key="item.tagId" @click.stop="choose(key, item.tagId)">
              {{ item.tagName }}
              <span class="status" :class="{'icon-checked-mini': item.checked, 'icon-uncheck-mini': !item.checked}"></span>
            </div>
          </div>
        </dd>
      </dl>
      <div class="selectBtn"
        @click.stop="addTag"
        :class="{opacity: selectList.length < 2}">（已选 {{ selectList.length }} 个）<span v-if="chooseList.length < 2">请至少选择两个</span><span v-else>进入病例练习</span></div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue'
import { userTagList, addUserTag } from '@api/exercise'
import { isLogin, prevPageView } from "@/widget/index"
export default defineComponent({
  props: {
    openPop: {
      type: Boolean,
      default: false
    },
    depId: {
      default: ''
    }
  },
  data () {
    return {
      bl: false,
      list: [],
      selectList: [], // 用户当前选择的标签
      chooseList: [] // 用户已选择的标签列表
    }
  },
  watch: {
    openPop (n) {
      if (n && this.list.length === 0) {
        this.getList()
      }
    }
  },
  methods: {
    close() {
      this.bl = true;
      setTimeout(() => {
        this.$emit('controlPop', false)
        this.bl = false;
      }, 200)
    },
    choose(ind, id) {
      this.list[ind].checked = !this.list[ind].checked;
      if (this.list[ind].checked) {
        this.selectList.push(id)
      } else {
        var i = this.selectList.indexOf(id);
        this.selectList.splice(i, 1)
      }
      this.adjustArr()
    },
    backFn () {
      prevPageView()
    },
    adjustArr () {
      this.selectList = Array.from(new Set(this.selectList))
      this.selectList = this.selectList.sort((a, b) => {
        return a - b;
      })
    },
    addTag () {
      if (this.selectList.length >= 2) {
        addUserTag({
          tagIds: this.selectList,
          departmentId: this.depId
        }).then(res => {
          if (res.code === 200) {
            this.chooseList = this.selectList;
            this.$toast("添加成功")
            this.$emit('controlPop', false, true)
          }
        })
      } else {
        this.$toast('请至少选择两个兴趣标签')
      }
    },
    getList () {
      if (!isLogin) {
        return;
      }
      userTagList({
        departmentId: this.depId
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data
          this.list.map(item => {
            if (item.checked) {
              this.selectList.push(item.tagId)
              this.chooseList.push(item.tagId)
            }
          })
        } else {
          this.$toast(res.message)
        }
      })
    }
  }
})
</script>
<style scoped>
.van-icon {
  color: rgba(177, 177, 179, 1);
}
</style>
<style lang="scss" scoped>
.interestPage {
  width: 7.5rem;
  position: fixed;
  left: 50%;
  margin-left: -3.75rem;
  bottom: 0;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.6);
  z-index: 1000;
  .interestContent {
    width: 7.5rem;
    height: 95%;
    background: #fff url('~@/assets/img/exercise/Interest_tags_bg.png') no-repeat center top;
    background-size: 100% auto;
    border-radius: 0.24rem 0.24rem 0 0;
    position: relative;
    padding-top: 215px;
    box-sizing: border-box;
    top: 5%;
    bottom: 0;
    left: 0;
    z-index: 19;
    animation: linearUp 200ms linear;
    animation-fill-mode: forwards;
    &.active {
      animation: linearDown 200ms linear;
      animation-fill-mode: forwards;
    }
  }
}
.backBtn, .closeBtn {
  height: 56px;
  width: 56px;
  position: absolute;
  top: 32px;
}
.backBtn {
  left: 12px;
}
.closeBtn {
  right: 32px;
}
.listWrapper {
  width: 7.5 - 0.8rem;
  position: absolute;
  top: 2.15rem;
  left: 50%;
  margin-left: -3.35rem;
  bottom: 1rem;
  h4 {
    height: 60px;
    font-size: 44px;
    line-height: 60px;
  }
  dt {
    text-align: center;
    overflow: hidden;
    p {
      height: 40px;
      font-size: 28px;
      line-height: 40px;
      margin-top: 8px;
    }
  }
  .linearBg {
    height: 32px;
    background: linear-gradient(#fff, rgba(255, 255, 255, 0.1));
    position: absolute;
    top: 1.08rem;
    left: 0;
    right: 0;
    z-index: 99;
  }
  .listContent {
    width: 100%;
    justify-content: center;
    flex-wrap: wrap;
  }
  .listBox {
    position: absolute;
    bottom: 0;
    top: 1.08rem;
    overflow-y: auto;
    padding-top: 32px;
    .item {
      height: 72px;
      line-height: 72px;
      padding: 0 56px 0 20px;
      background: #F5F5F7;
      border-radius: 12px;
      box-sizing: border-box;
      font-size: 28px;
      margin-right: 24px;
      position: relative;
      margin-bottom: 24px;
    }
    .status {
      position: absolute;
      right: 20px;
      top: 8px;
    }
  }
}
.selectBtn {
  width: 686px;
  height: 88px;
  background: #FF6600;
  border-radius: 44px;
  color: #fff;
  position: absolute;
  bottom: 12px;
  left: 32px;
  line-height: 88px;
  text-align: center;
  font-size: 32px;
}
.opacity {
  opacity: 0.5;
}
</style>
<style>
.van-icon {
  font-size: 56px;
  color: RGBA(35, 35, 35, 1);
}
</style>
